import {
  GET_AD_GROUP_LOCATIONS,
  GET_AD_GROUP_LOCATIONS_SUCCESS,
  GET_AD_GROUP_LOCATIONS_ERROR,
} from "./actionTypes"

const initialState = {
  ad_group_locations: {},
  error: null,
  loading: false,
}

const AdGroupLocations = (state = initialState, action) => {
  switch (action.type) {
    case GET_AD_GROUP_LOCATIONS:
      return {
        ...state,
        loading: true,
        error: null,
      }
    case GET_AD_GROUP_LOCATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        ad_group_locations: action.payload,
      }
    case GET_AD_GROUP_LOCATIONS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      }
    default:
      return state
  }
}

export default AdGroupLocations
